module.exports = __webpack_public_path__ + "img/mitigation.1b859f98.png";